import { render, staticRenderFns } from "./kpsrRelationDocu.vue?vue&type=template&id=2290cb6d"
import script from "./kpsrRelationDocu.vue?vue&type=script&lang=js"
export * from "./kpsrRelationDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2290cb6d')) {
      api.createRecord('2290cb6d', component.options)
    } else {
      api.reload('2290cb6d', component.options)
    }
    module.hot.accept("./kpsrRelationDocu.vue?vue&type=template&id=2290cb6d", function () {
      api.rerender('2290cb6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/plan/kpsrRelationDocu.vue"
export default component.exports